import * as React from "react";
const SvgDescending = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 6, viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M1 1L4 4L7 1", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgDescending;
